module.exports = ".bx-inner-perfil-intermediarios-msi form {\r\n  border-radius: 30px;\r\n  border: 1px solid #ddd;\r\n  padding: 20px;\r\n  padding-top: 5px;\r\n  padding-bottom: 30px;\r\n}\r\n.row{\r\n  margin-top: 1rem;\r\n}\r\n.bx-intermediarios-msi .box-form-it-msi {\r\n  max-width: 100%;\r\n  width: 70%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/intermediarios/registro/registro.component.css
// module id = ./src/app/components/intermediarios/registro/registro.component.css
// module chunks = main